import { render, staticRenderFns } from "./StitchedMCQEdit.vue?vue&type=template&id=66d1a8f2&"
import script from "./StitchedMCQEdit.vue?vue&type=script&lang=js&"
export * from "./StitchedMCQEdit.vue?vue&type=script&lang=js&"
import style0 from "./StitchedMCQEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports